import React ,{ useState } from 'react';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Mail, 
  Phone, 
  MapPin, 
  Code,
  Linkedin 
} from 'lucide-react';

const WildlifeFooter = () => {
  const currentYear = new Date().getFullYear();

  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = () => {
    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setError('Email is required.');
      return;
    }

    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setError('');
      alert(`Thank you for subscribing with ${email}!`);
    }, 1000);
  };


  return (
    <footer className="bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 text-slate-800 dark:text-slate-200">
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand Section */}
        <div className="flex flex-col items-start space-y-4">
          <div className="flex items-center">
            <Code className="mr-3 text-indigo-600 dark:text-indigo-400" size={36} />
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">
              Pixel Meta Lab
            </h2>
          </div>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed">
            Innovative digital marketing solutions that transform your online presence through cutting-edge technology and strategic insights.
          </p>
          <div className="flex space-x-5">
            {[
              { icon: <Facebook className="hover:text-indigo-600" />, label: "Facebook" },
              { icon: <Twitter className="hover:text-indigo-600" />, label: "Twitter" },
              { icon: <Linkedin className="hover:text-indigo-600" />, label: "LinkedIn" }
            ].map(({ icon, label }) => (
              <a 
                href="#" 
                className="text-slate-500 dark:text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                aria-label={label}
                key={label}
              >
                {React.cloneElement(icon, { size: 24 })}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-6 pb-2 border-b border-indigo-500 dark:border-indigo-400 text-slate-900 dark:text-white">
            Quick Navigation
          </h3>
          <div className="grid grid-cols-2 gap-4">
            {[
              { name: 'Services', href: '#services' },
              { name: 'Portfolio', href: '#' },
              { name: 'About Us', href: '#' },
              { name: 'Blog', href: '#' },
              { name: 'Contact', href: '#' },
              { name: 'Careers', href: '#' }
            ].map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                className="text-slate-600 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors text-sm"
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>

        {/* Contact Information */}
        <div>
          <h3 className="text-xl font-semibold mb-6 pb-2 border-b border-indigo-500 dark:border-indigo-400 text-slate-900 dark:text-white">
            Get in Touch
          </h3>
          <div className="space-y-4">
            {[
              { 
                icon: <Phone className="text-indigo-600 dark:text-indigo-400" size={20} />, 
                text: '+94 769223983' 
              },
              { 
                icon: <Mail className="text-indigo-600 dark:text-indigo-400" size={20} />, 
                text: 'hello@pixelmetalab.com' 
              },
              { 
                icon: <MapPin className="text-indigo-600 dark:text-indigo-400" size={20} />, 
                text: 'No.88 B1/1, S.De S Jayasinghe Mawatha,Kohuwala' 
              }
            ].map(({ icon, text }) => (
              <div key={text} className="flex items-center space-x-3">
                {icon}
                <span className="text-slate-600 dark:text-slate-300 text-sm">{text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Newsletter Signup */}
        <div>
            <h3 className="text-xl font-semibold mb-6 pb-2 border-b border-indigo-500 dark:border-indigo-400 text-slate-900 dark:text-white">
              Stay Updated
            </h3>
            <p className="text-slate-600 dark:text-slate-300 mb-4 text-sm">
              Subscribe to our newsletter for digital marketing insights and industry trends.
            </p>
            <div className="flex rounded-lg shadow-sm">
              <input 
                type="email" 
                placeholder="Your email address" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 text-sm text-slate-900 dark:text-slate-100 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
                disabled={isSubscribed}
              />
              <button 
                onClick={handleSubscribe}
                className="bg-indigo-600 text-white px-5 py-3 rounded-r-lg hover:bg-indigo-700 dark:bg-indigo-700 dark:hover:bg-indigo-800 transition-colors text-sm"
                disabled={isSubscribed}
              >
                {isSubscribed ? 'Subscribed' : 'Subscribe'}
              </button>
            </div>
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
          </div>
        </div>

      {/* Copyright Section */}
      <div className="mt-12 pt-8 border-t border-slate-200 dark:border-slate-700 text-center">
        <p className="text-slate-600 dark:text-slate-400 text-sm">
          © {currentYear} Pixel Meta Lab. All Rights Reserved.
          <span className="block text-xs mt-2 text-slate-500 dark:text-slate-500">
            Transforming Digital Landscapes with Innovative Marketing Solutions
          </span>
        </p>
      </div>
    </div>
  </footer>
  );
};

export default WildlifeFooter;